import React, { useRef } from "react";
import { IconButton } from "@mui/material";
import { Send } from "@mui/icons-material";
import VoiceChat from "core/components/global/input/voice/voiceChat";

interface ChatInputProps {
  apptheme: any;
  userPrompt: string;
  setUserPrompt: (value: string) => void;
  postData: () => void;
  handleVoiceInput: (text: string) => void;
  sendMessageByVoice: (data: any) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({
  apptheme,
  userPrompt,
  setUserPrompt,
  postData,
  handleVoiceInput,
  sendMessageByVoice
}) => {
  const contentEditableRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={`${apptheme.name === "dark-theme" ? "bg-[linear-gradient(to_bottom,transparent_0%,#1d1d1d_20%)]" : ""} px-4 pb-4 pt-2`}>
      <div className={`flex items-center gap-2 ${apptheme.name === "dark-theme" ? "bg-[linear-gradient(to_bottom,transparent_0%,#1d1d1d_20%)]" : "bg-[#faf5ff]"} px-3 rounded-lg border mb-3 ml-5`}>
        <input
          ref={contentEditableRef}
          placeholder="Type your message..."
          className={`flex-1 outline-none border-none bg-transparent p-3 ${apptheme.name === "dark-theme" ? "text-white !important" : "text-black"}`}
          onChange={(e) => setUserPrompt(e.target.value)}
          value={userPrompt}
          onKeyPress={(e) => e.key === 'Enter' && postData()}
        />
        <div className="flex gap-1">
          <div className="align-self-center">
            <VoiceChat
              sendDataToParent={handleVoiceInput} 
              sendMessageByVoice={sendMessageByVoice} 
            />
          </div>
          <IconButton 
            onClick={postData} 
            className={`${apptheme.name === "dark-theme" ? "text-white !important" : "text-black"}`}
          >
            <Send />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ChatInput);